<template>
  <div>
    <h5 @click.prevent.stop="onCollapse" class="collapse-group-header">
      {{collapse ? '&#9654;' : '&#9660;'}}
      {{title}}
    </h5>
    <transition name="fade">
      <div v-show="!collapse" class="collapse-group-content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  props: {
    title: {
    },
    initCollapse: {
      default: false
    }
  },
  data: () => ({
    collapse: false
  }),
  created() {
    this.collapse = this.initCollapse || false;
  },
  methods: {
    onCollapse(group) {
      this.collapse = !this.collapse;
    },
  }
}
</script>

<style>
.collapse-group-content {
  padding: 0.5em;
  padding-left: 1.5em;
  margin-bottom: 0.5em;
  /* background-color: #f6f6f6; */
}
.collapse-group-header {
  display: inline;
  margin-top: 0.5em;
  margin-bottom: 0.2em;
  cursor: pointer;

  font-size: 9pt;
  font-weight: bold;
  color: #666;
  text-transform: uppercase;
}
</style>
